var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shadow"},[_c('header',{staticClass:"a-header header-layout"},[_c('div',{staticClass:"header-title"},[_c('h1',{staticClass:"title"},[_vm._v("RCS平台物模型")])])])])
}]

export { render, staticRenderFns }